import { render } from "./ChangeMaterialsList.vue?vue&type=template&id=2adeb728"
import script from "./ChangeMaterialsList.vue?vue&type=script&lang=js"
export * from "./ChangeMaterialsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QLinearProgress,QScrollArea,QList,QItem,QItemSection,QSeparator,QBtn});qInstall(script, 'directives', {Ripple});
